"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Heart, Lightbulb, Zap } from "lucide-react";
export default function MiHistoriaYEnfoque() {
  const {
    ref: section1Ref,
    isVisible: section1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section2Ref,
    isVisible: section2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section3Ref,
    isVisible: section3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="bg-dark-background text-foreground-dark ![margin:64px_0px_64px_0px] ![padding:64px_24px_64px_24px]">
      <div className="max-w-3xl mx-auto space-y-12">
        {}
        <div ref={section1Ref} className={`flex items-start gap-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${section1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <div className="flex-shrink-0 mt-1 group">
            <Heart className="w-8 h-8 text-foreground-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:text-accent" strokeWidth={1.5} />
          </div>
          <div className="space-y-4">
            <h3 className="text-2xl font-display font-semibold text-foreground-dark">
              Empatía: entiendo tu estancamiento
            </h3>
            <p className="text-base leading-relaxed text-foreground-dark/90">
              Sé lo que es sentirse atrapado, sin claridad sobre el siguiente paso. He vivido momentos de duda y bloqueo, y esa experiencia me permite conectar genuinamente con lo que estás atravesando. No estás solo en esto.
            </p>
          </div>
        </div>

        {}
        <div ref={section2Ref} className={`flex items-start gap-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${section2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        transitionDelay: section2Visible ? "100ms" : "0ms"
      }}>
          <div className="flex-shrink-0 mt-1 group">
            <Lightbulb className="w-8 h-8 text-foreground-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:text-accent" strokeWidth={1.5} />
          </div>
          <div className="space-y-4">
            <h3 className="text-2xl font-display font-semibold text-foreground-dark">
              Claridad: un enfoque directo y sin vueltas
            </h3>
            <p className="text-base leading-relaxed text-foreground-dark/90">
              Mi método es claro y práctico. Nada de promesas vacías ni recetas mágicas. Trabajamos juntos para identificar qué te frena, cómo superarlo y qué pasos concretos dar. Sin rodeos, con honestidad y respeto por tu proceso.
            </p>
          </div>
        </div>

        {}
        <div ref={section3Ref} className={`flex items-start gap-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${section3Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        transitionDelay: section3Visible ? "200ms" : "0ms"
      }}>
          <div className="flex-shrink-0 mt-1 group">
            <Zap className="w-8 h-8 text-foreground-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:text-accent" strokeWidth={1.5} />
          </div>
          <div className="space-y-4">
            <h3 className="text-2xl font-display font-semibold text-foreground-dark">
              Acción: resultados reales, no solo conversación
            </h3>
            <p className="text-base leading-relaxed text-foreground-dark/90">
              El coaching es para avanzar, no para quedarse dando vueltas. Diseño cada sesión para que salgas con herramientas concretas y un plan de acción. Mi compromiso es que cada encuentro te acerque a recuperar tu confianza y claridad.
            </p>
          </div>
        </div>
      </div>
    </section>;
}